<template>
  <div class="wrapper">
    <base-bread-crumb :currBreadCrumb="currBreadCrumb"></base-bread-crumb>
    <div class="ccui-app-container-detail">
      <div class="ccui-app-container">
        <!--高级搜索Begin-->
        <div class="ccui-advanced-search-wrapper ccui-clearfix">
          <el-search
            ref="elSearch"
            width="460px"
            :formProp="formData"
            @search="search"
            :isShowSearch="true"
            class="ccui-highsearch no-print"
          >
            <template slot="search">
              <el-input
                v-model.trim="formData.noticeTitle"
                clearable
                searchLabel="标题"
                placeholder="请输入标题"
              ></el-input>
              <el-select
                v-model="formData.matBigClasses"
                clearable
                placeholder="请选择"
                searchLabel="请选择大类"
              >
              </el-select>
              <el-date-picker
                v-model="formData.noticeTime"
                searchLabel="发布时间"
                clearable
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="请选择"
                end-placeholder="请选择"
              >
              </el-date-picker>
            </template>
            <el-input
              v-model.trim="formData.supName"
              clearable
              searchLabel="标题"
              placeholder="请输入标题"
              slot="searchItem1"
            ></el-input>
            <el-select
              v-model="formData.auditStatusShow"
              clearable
              placeholder="请选择"
              searchLabel="请选择大类"
              slot="searchItem2"
            >
            </el-select>
            <el-date-picker
              v-model="formData.applyTime"
              searchLabel="发布时间"
              clearable
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="请选择"
              end-placeholder="请选择"
              slot="searchItem3"
            >
            </el-date-picker>
          </el-search>
        </div>
        <!--高级搜索End-->
        <!--table表格区域Begin-->
        <div class="ccui-multifunctional-table-wrapper">
          <listBaseTable
            :tableName="tableName"
            :showCheckBox="false"
            :showOp="false"
            :data="tableData"
            :cellStyle="cellStyle"
            :pageNo.sync="pageNo"
            :pageSize.sync="pageSize"
            :pageTotal="pageTotal"
            :fixedTableThead="fixedTableThead"
            :unfixedTableThead="unfixedTableThead"
            border
            @handleList="handleList"
            @select-all="handleCheckAllChange"
            @select="handleCheckChange"
            @selection-change="handleSelectionChange"
          >
            <!--列表中的插槽Begin-->
            <template slot="noticeTitle" slot-scope="{ row }">
              <el-button size="mini" type="text" @click="check(row)">
                {{ row.noticeTitle }}
              </el-button>
            </template>
            <!--列表中的插槽End-->
          </listBaseTable>
        </div>
        <!--table表格区域End-->
      </div>
    </div>
  </div>
</template>
<script>
import { listSupBidNotice } from "@/app/shop/api/shopping";
import { mixinListCommon } from "@/mixins/mixin-common/mixin-list";
import { commonTableWidth } from "@/setting/setting";
import baseBreadCrumb from "@/app/shop/components/baseBreadCrumb.vue";
export default {
  name: "viewMore",
  mixins: [mixinListCommon],
  components: {
    baseBreadCrumb
  },
  activated() {
    this.getNoticeList();
  },
  deactivated() {
    this.initData();
  },
  data() {
    return {
      tableName: this.tableList.viewMoreList, // 默认的tableName 工程中唯一
      auditStatusOptions: [],
      isSelection: false,
      formData: {},
      formDataSearch: {},
      tableData: [],
      unfixedTableTheadAll: [],
      fixedTableThead: [],
      unfixedTableThead: Object.freeze([
        {
          label: "序号",
          prop: "id",
          type: "index",
          width: commonTableWidth.serialNoWidth,
          checked: true
        },
        {
          label: "公告标题",
          prop: "noticeTitle",
          checked: true,
          width: commonTableWidth.supplierName,
          slot: "noticeTitle"
        },
        {
          label: "公告发布时间",
          prop: "noticeStartTime",
          width: commonTableWidth.dateTimeWidth,
          checked: true
        }
      ]),
      pageNo: 1,
      pageSize: 10,
      pageTotal: 0,
      currBreadCrumb: [{ title: "采购公告" }, { title: "更多 >" }]
    };
  },
  methods: {
    initData() {
      this.pageNo = 1;
      this.pageSize = 10;
      this.pageTotal = 0;
      this.formData = {};
      this.tableName = this.tableList.viewMoreList;
    },
    handleList() {
      // 分页操作列表
      this.getNoticeList();
    },
    getNoticeList() {
      let param = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        isShowPageLoading: true,
        noticeType: 1
      };
      if (
        this.formDataSearch.noticeTime &&
        this.formDataSearch.noticeTime.length !== 0
      ) {
        this.formDataSearch.noticeStartTime = this.formDataSearch.noticeTime[0];
        this.formDataSearch.noticeEndTime = this.formDataSearch.noticeTime[1];
      }
      Object.assign(param, this.formDataSearch);
      this.$delete(param, "noticeTime");
      listSupBidNotice(param).then(res => {
        if (res.data.code === "0") {
          this.tableData = res.data.data.rows;
          this.pageTotal = res.data.data.recordsTotal;
        }
      });
    },
    search(searchData) {
      this.pageNo = 1;
      this.formDataSearch = searchData;
      this.getNoticeList();
    },
    //查看
    check(item) {
      this.$router.push({
        path: "/noticeDetail",
        query: {
          schemeId: item.schemeId,
          noticeId: item.noticeId,
          opUnitName: item.opUnitName
        }
      });
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      // 判断高亮行
      return { color: "#0089EF", cursor: "pointer" };
    },
    handleCheckAllChange(arr) {
      this.isSelection = arr.length !== 0;
    },
    handleCheckChange(arr) {
      this.isSelection = arr.length !== 0;
    },
    handleSelectionChange(arr) {
      this.isSelection = arr.length !== 0;
    }
  }
};
</script>

<style lang="scss" scoped></style>
